import { Button, Dialog, Grid } from '@material-ui/core';
import HomePageCard from '../../home/card';
import en from '../../../lang/en-us';
import { useEffect, useState } from 'react';
import { getPortfolio } from '../../../redux-store/actions/portfolio';
import { connect, useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { CombinedState } from 'redux';
import { RouteComponentProps } from 'react-router';
import { getNotifications } from '../../../redux-store/actions/login';
import {
    AuthState,
    CLEAR_POPUP_STATUS,
    NotificationPayload,
    REDIRECT_ACTION,
} from '../../../redux-store/types/login';
import { IsAllow } from '../../../redux-store/types/portfolio';

const { dashboard, common } = en;
interface HomeProps extends RouteComponentProps {
    getNotifications: (body: NotificationPayload) => Promise<any>;
    displayName: string;
    unmatched: string[];
    mobile: string;
    email: string;
    pan: string;
    pekrn: string;
    reqId: string;
    redirectPath: string;
    enablePin: boolean;
    updateFirstTimeSettings: (body: Partial<AuthState>) => void;
    screenFlow: 'PIN_SET' | 'FINGER_PRINT' | 'HOME';
    enableTwoFactorAuth: boolean;
    showPopUp: IsAllow;
    message: string;
}

export function FundInfoDialog({
    fundInfoShow = false,
    setFundInfoShow,
}: {
    fundInfoShow: boolean;
    setFundInfoShow: (value: boolean) => void;
}) {
    return (
        <Dialog maxWidth={'md'} open={fundInfoShow} aria-labelledby="note-modals">
            <div style={{ maxWidth: 700 }} className="note-modals">
                <h3>{dashboard.noteModals.nctModal.heading}</h3>
                <div style={{ textAlign: 'left' }}>
                    <p style={{ marginBottom: 15 }}>{common.fundInfoModal.info1}</p>
                    <p style={{ marginBottom: 15 }}>{common.fundInfoModal.info2}</p>
                    <p style={{ marginBottom: 35 }}>{common.fundInfoModal.info3}</p>
                </div>
                <div className="note-modals-btns">
                    <Button className="customBtn" onClick={() => setFundInfoShow(!fundInfoShow)}>
                        {'OK'}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
}

export function Info({
    info = '',
    icon = 'info2.svg',
    onClick,
}: {
    info?: string;
    icon?: string;
    onClick?: React.MouseEventHandler<HTMLImageElement>;
}) {
    return (
        // <CustomToolTip arrow title={info}>
        <img
            onClick={onClick}
            style={{
                width: 22,
                cursor: 'pointer',
                margin: 0,
                marginLeft: 10,
                position: 'relative',
            }}
            src={`/images/${icon}`}
            alt="info"
        />
        // </CustomToolTip>
    );
}

const isMessageHTML = (message: string) => {
    const tagsToFind = ['<div>', '<p>', '<h1>'];
    for (let i = 0; i < tagsToFind.length; ++i) {
        if (message.search(tagsToFind[i]) >= 0) {
            return true;
        }
    }
    return false;
};

function Home({ displayName = '', unmatched = [], ...props }: HomeProps) {
    const [show, setShow] = useState<boolean>(false);
    const [showAmcModal, setShowAmcModal] = useState(
        props.showPopUp?.toUpperCase() === IsAllow.YES,
    );
    const [fundInfoShow, setFundInfoShow] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { ftTransactionFlag } = useSelector(({ authReducer }: RootStateType) => ({
        ftTransactionFlag: authReducer?.ftTransactions,
    }));
    const shouldParseMessageAsHTML = isMessageHTML(props.message);
    useEffect(() => {
        async function callApi() {
            try {
                const { mobile, email, pan, reqId, pekrn } = props;
                await props.getNotifications({ mobile, email, pan, pekrn, reqId });
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        if (!!props.redirectPath) {
            dispatch({ type: REDIRECT_ACTION, body: { redirectPath: null } });
            props.history.replace(props.redirectPath);
        }
    }, []);

    const _goToLink = (url: string) => () => {
        window.open(url, 'blank');
    };

    const modalShow = (e: any) => {
        e.stopPropagation();
        setFundInfoShow(true);
    };

    return (
        <div>
            <HomePageCard className="db-banner db-welcome">
                <>
                    <img
                        className="db-banner-character"
                        src="/images/db-home-character.png"
                        alt="icon"
                    />
                    <h3>
                        <b>{en.dashboard.dashboardHome.welcome.welcome}</b>{' '}
                        {displayName[0] + displayName.slice(1)}
                    </h3>
                    <p>{en.dashboard.dashboardHome.welcome.info}</p>
                    {!!unmatched.length && (
                        <div className="db-welcome-bottom">
                            <div className="db-welcome-notification">
                                <img src="/images/unregistered-folio.svg" alt="icon" />
                                <a
                                    onClick={() =>
                                        props.history.push('/portal/unregistered-folios')
                                    }
                                >
                                    {/* {en.dashboard.dashboardHome.welcome.notificationinfoLeft}
                                    {unmatched.length}
                                    {en.dashboard.dashboardHome.welcome.notificationinfoRight} */}
                                    {en.dashboard.dashboardHome.welcome.unregisteredFolios}
                                    <img src="/images/right-arrow-white.svg" alt="icon" />
                                </a>
                            </div>
                            {/* <div className="db-welcome-date">
                                <h4>10:10</h4>
                                <h5>
                                Tuesday <span>1 June, 2021</span>
                                </h5>
                            </div> */}
                        </div>
                    )}
                </>
            </HomePageCard>
            <Grid container spacing={0} xs={12} className="db-grid-boxes db-quick-link-boxes">
                <Grid item xs={12} sm={4}>
                    <a onClick={() => props.history.push('/portal/portfolio')}>
                        <HomePageCard className="db-grid-portfolio">
                            <div className="db-grid-boxes-info">
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <h3 style={{ marginBottom: 0 }}>
                                        {en.dashboard.dashboardHome.quicklinks.box1.heading}{' '}
                                        <span>
                                            {' '}
                                            {en.dashboard.dashboardHome.quicklinks.box1.headingBold}
                                        </span>{' '}
                                    </h3>
                                    <Info onClick={modalShow} info={'Portfolios'} />
                                </div>
                                <p> {en.dashboard.dashboardHome.quicklinks.box1.info}</p>
                                <img src="/images/view-portfolio.svg" alt="icon" />
                            </div>
                        </HomePageCard>
                    </a>
                </Grid>
                {ftTransactionFlag === IsAllow.YES ? (
                    <Grid item xs={12} sm={4}>
                        <a onClick={() => props.history.push('/portal/commercial/actions')}>
                            <HomePageCard className="db-grid-track">
                                <div className="db-grid-boxes-info">
                                    <h3 style={{ display: 'inline-flex', alignItems: 'center' }}>
                                        <span>
                                            {en.dashboard.dashboardHome.quicklinks.box4.heading}
                                        </span>{' '}
                                        <img
                                            className="new-icon-box"
                                            style={{ marginLeft: 10 }}
                                            src="/images/new_icon.svg"
                                            alt="icon"
                                        />
                                    </h3>
                                    <p>{en.dashboard.dashboardHome.quicklinks.box4.info}</p>
                                    <img src="/images/track-status.svg" alt="icon" />
                                </div>
                            </HomePageCard>
                        </a>
                    </Grid>
                ) : (
                    <Grid item xs={12} sm={4}>
                        <a onClick={() => props.history.push('/portal/track')}>
                            <HomePageCard className="db-grid-track">
                                <div className="db-grid-boxes-info">
                                    <h3>
                                        {en.dashboard.dashboardHome.quicklinks.box3.heading}{' '}
                                        <span>
                                            {' '}
                                            {en.dashboard.dashboardHome.quicklinks.box3.headingBold}
                                        </span>{' '}
                                    </h3>
                                    <p>{en.dashboard.dashboardHome.quicklinks.box3.info}</p>
                                    <img src="/images/track-status.svg" alt="icon" />
                                </div>
                            </HomePageCard>
                        </a>
                    </Grid>
                )}
                <Grid item xs={12} sm={4}>
                    <a onClick={() => setShow(true)}>
                        <HomePageCard className="db-grid-nct">
                            <div className="db-grid-boxes-info">
                                <h3>
                                    {en.dashboard.dashboardHome.quicklinks.box2.heading}{' '}
                                    <span>
                                        {' '}
                                        {en.dashboard.dashboardHome.quicklinks.box2.headingBold}
                                    </span>
                                </h3>
                                <p>{en.dashboard.dashboardHome.quicklinks.box2.info}</p>
                                <img src="/images/make-nct.svg" alt="icon" />
                            </div>
                        </HomePageCard>
                    </a>
                </Grid>
            </Grid>
            <div className="db-home-sliders db-cards">
                <div className="db-home-slider">
                    <img src="/images/db-home-slider1.png" alt="icon" />
                    <div className="db-home-slider-info">
                        <h5>
                            <a
                            // target="_blank"
                            // href="https://www.etmoney.com/blog/how-to-choose-mutual-funds-for-the-short-term/"
                            >
                                {en.dashboard.dashboardHome.slider.slider1.text}
                            </a>
                        </h5>
                        {/* <p>
                            <img src="/images/time.svg" alt="icon" />1 June, 2021
                        </p> */}
                    </div>
                </div>
            </div>
            <Dialog maxWidth={'sm'} open={show} aria-labelledby="note-modals">
                <div className="note-modals">
                    <h3>{dashboard.noteModals.nctModal.heading}</h3>
                    <p>{dashboard.noteModals.nctModal.info}</p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            onClick={() => props.history.push('/portal/nct')}
                        >
                            {dashboard.noteModals.nctModal.proceedText}
                        </Button>
                        <Button className="customBtn cancelBtn" onClick={() => setShow(!show)}>
                            {dashboard.noteModals.nctModal.cancelText}
                        </Button>
                    </div>
                </div>
            </Dialog>
            <Dialog maxWidth={'md'} open={showAmcModal} aria-labelledby="note-modals">
                <div style={{ maxWidth: 530 }} className="note-modals">
                    <h3>{dashboard.noteModals.nctModal.heading}</h3>
                    <div
                        className="message-popup"
                        style={{ textAlign: 'center' }}
                        dangerouslySetInnerHTML={{
                            __html: shouldParseMessageAsHTML
                                ? props.message
                                : `<p style={{ marginBottom: 15 }}>${props.message}</p>`,
                        }}
                    >
                    </div>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            onClick={() => {
                                setShowAmcModal(false);
                                dispatch({ type: CLEAR_POPUP_STATUS });
                            }}
                        >
                            Ok
                        </Button>
                    </div>
                </div>
            </Dialog>
            <FundInfoDialog fundInfoShow={fundInfoShow} setFundInfoShow={setFundInfoShow} />
        </div>
    );
}

export default connect(({ authReducer }: CombinedState<RootStateType>) => ({ ...authReducer }), {
    getPortfolio,
    getNotifications,
})(Home);
